import React, { useState } from "react";
import styled from "@emotion/styled";
import { SubscribeTabOne, SubscribeTabTwo } from "@pages/myPage/index";

const Container = styled.div({});

const Subscribe = () => {
  const [tab, setTab] = useState(0);

  if (tab === 0) {
    return <SubscribeTabOne tab={tab} setTab={setTab} />;
  }
  if (tab === 1) {
    return <SubscribeTabTwo tab={tab} setTab={setTab} />;
  }

  return null;
};

export default Subscribe;
